import React, { useState } from 'react'
import Link from 'next/link'

import { DirectoryLinkAs, DirectoryLinkHref, Reset } from 'utils/DirectoryParser'
import { FlexDiv, P } from 'components/generic/HomePageComponents'
import SearchInputs from 'components/Directories/SearchFacetsContainer/SearchInputs'
import TextInput from 'components/Directories/SearchFacetsContainer/TextInput'
import ProvidersContainer from 'components/Directories/SearchFacetsContainer/ProvidersContainer'
import FacetsContainer from 'components/Directories/SearchFacetsContainer/FacetsContainer'
import LocationsContainer from 'components/Directories/SearchFacetsContainer/LocationsContainer'
import LanguageDropdown from 'components/Directories/SearchFacetsContainer/LanguageDropdown'
import {
  SmallSearchContentContainer,
  PHover,
  DropDownButton,
} from 'components/Directories/SearchFacetsContainer/Styled'

const SEARCH_PROMPT = 'Search by Keyword'

const TextAndIcon = (props) => <FlexDiv justifyContent='center'>{props.children}</FlexDiv>

const DropDownButtonWithIcon = ({ handleClick, showDropDown }) => (
  <DropDownButton onClick={handleClick} showDropDown={showDropDown}>
    <TextAndIcon>{showDropDown ? 'Hide Filters' : 'Show Filters'}</TextAndIcon>
  </DropDownButton>
)

export const SmallSearchContainer = ({
  siteDirectoryResultsTypes,
  directoryProviderFacetSlug,
  directoryProviderFacetKeyword,
  directoryResultsType,
  providerFacetName,
  providerRadioFacets,
  providerMultiSelectFacets,
  otherFacets,
  selectedFacets,
  directoryLinkInformation,
  keyword,
  locationOptions,
  postalCodeUpdate,
  postalRadiusUpdate,
  invalidPostalCode,
  languages,
  selectedLanguageId,
  setLanguage,
  resetFilters,
  nearestLocation,
}) => {
  const [showDropDown, setShowDropDown] = useState(false)
  const resetDirectoryLinkInformation = Reset(directoryLinkInformation, siteDirectoryResultsTypes)
  const resetDirectoryLinkHref = DirectoryLinkHref(resetDirectoryLinkInformation)
  const resetDirectoryLinkAs = DirectoryLinkAs(resetDirectoryLinkInformation)
  const selectedLanguage = languages.find((language) => language.id === selectedLanguageId)

  return (
    <FlexDiv display={{ _: 'flex', tablet: 'none' }} flexDirection='column'>
      <DropDownButtonWithIcon
        handleClick={() => setShowDropDown(!showDropDown)}
        showDropDown={showDropDown}
      />
      <SmallSearchContentContainer isShown={showDropDown}>
        <FlexDiv justifyContent='space-between'>
          <P lineHeight='20px' fontWeight='bold'>
            Search For:
          </P>
          <Link scroll={false} href={resetDirectoryLinkHref} as={resetDirectoryLinkAs}>
            <PHover onClick={resetFilters}>Reset Filters</PHover>
          </Link>
        </FlexDiv>
        <SearchInputs
          directoryLinkInformation={directoryLinkInformation}
          siteDirectoryResultsTypes={siteDirectoryResultsTypes}
          directoryResultsType={directoryResultsType}
        />
        <TextInput
          placeholder={SEARCH_PROMPT}
          textValue={keyword}
          directoryLinkInformation={directoryLinkInformation}
        />
        <LocationsContainer
          locationOptions={locationOptions}
          directoryLinkInformation={directoryLinkInformation}
          postalCodeUpdate={postalCodeUpdate}
          postalRadiusUpdate={postalRadiusUpdate}
          nearestLocation={nearestLocation}
          invalidPostalCode={invalidPostalCode}
        />
        {languages && languages.length > 0 && (
          <LanguageDropdown
            languages={languages}
            setLanguage={setLanguage}
            selectedLanguage={selectedLanguage}
          />
        )}
        <ProvidersContainer
          facetName={providerFacetName}
          providerRadioFacets={providerRadioFacets}
          providerMultiSelectFacets={providerMultiSelectFacets}
          directoryProviderFacetSlug={directoryProviderFacetSlug}
          directoryProviderFacetKeyword={directoryProviderFacetKeyword}
          directoryLinkInformation={directoryLinkInformation}
          siteDirectoryResultsTypes={siteDirectoryResultsTypes}
        />
        <FacetsContainer
          facetGroups={otherFacets}
          selectedFacets={selectedFacets}
          directoryLinkInformation={directoryLinkInformation}
        />
      </SmallSearchContentContainer>
    </FlexDiv>
  )
}
